module.exports = __webpack_public_path__ + "static/media/blue_logo.3d694e4b.png";